/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetServerOptions200ResponseDataValues } from './GetServerOptions200ResponseDataValues'
import {
  GetServerOptions200ResponseDataValuesFromJSON,
  GetServerOptions200ResponseDataValuesFromJSONTyped,
  GetServerOptions200ResponseDataValuesToJSON,
} from './GetServerOptions200ResponseDataValues'

/**
 *
 * @export
 * @interface GetServerOptions200ResponseData
 */
export interface GetServerOptions200ResponseData {
  /**
   *
   * @type {GetServerOptions200ResponseDataValues}
   * @memberof GetServerOptions200ResponseData
   */
  values: GetServerOptions200ResponseDataValues
}

/**
 * Check if a given object implements the GetServerOptions200ResponseData interface.
 */
export function instanceOfGetServerOptions200ResponseData(
  value: object
): value is GetServerOptions200ResponseData {
  if (!('values' in value) || value['values'] === undefined) return false
  return true
}

export function GetServerOptions200ResponseDataFromJSON(
  json: any
): GetServerOptions200ResponseData {
  return GetServerOptions200ResponseDataFromJSONTyped(json, false)
}

export function GetServerOptions200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetServerOptions200ResponseData {
  if (json == null) {
    return json
  }
  return {
    values: GetServerOptions200ResponseDataValuesFromJSON(json['values']),
  }
}

export function GetServerOptions200ResponseDataToJSON(
  value?: GetServerOptions200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    values: GetServerOptions200ResponseDataValuesToJSON(value['values']),
  }
}
